import React from 'react'
// nodejs library to set properties for components
import PropTypes from 'prop-types'

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
import Grid from '@material-ui/core/Grid'

const style = theme => ({
  section: {
    paddingTop: '80px',
    paddingBottom: '50px',
    minHeight: '100vh',
    width: '100vw',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.palette.grey[50],
  },
})

const withSection = ({ id }) => Component => {
  const withSection = ({ classes, background, ...props }) => {
    return (
      <section
        id={props.name || id}
        className={classes.section}
        style={{ backgroundColor: background }}
      >
        <Grid container justify="center" spacing={0}>
          <Grid item xs={11} md={10} lg={10}>
            <Component {...props} />
          </Grid>
        </Grid>
      </section>
    )
  }

  return withStyles(style)(withSection)
}

withSection.propTypes = {
  id: PropTypes.string.isRequired,
}

export default withSection
